export default __webpack_public_path__ + "static/media/7.42118de3.svg";